import { RestApiResponse } from "./RestApi";
import { BaseResponseAttributes } from "../attributes/base-attributes";
import BaseService from "./BaseService";

export class BusinessBranchService extends BaseService {
  static async searchByName(
    query: string
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    const url: string = "business-branches/search";

    return BusinessBranchService.getPublicApiClient().get(url, {
      params: { query: query },
    });
  }

  static async checkById(
    id: string
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    const url: string = "business-branches/" + id;

    return BusinessBranchService.getPublicApiClient().get(url);
  }

  static async getOpeningHours(
    branchId: number
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessBranchService.getApiClient().get(
      `business-branches/${branchId}/opening-hours`
    );
  }
}

export default BusinessBranchService;
